<script lang="ts" setup>
import type { PropType } from "vue";
import { computed } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Application } from "@/types/order/Application";
import WorkInfoTable from "@/views/applications/organisms/WorkInfoTable.vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
});

const attendanceCorrectionRoute = computed(() => ({
  name: "AttendanceCorrection",
  params: {
    applicationId: props.application.id.toString()
  }
}));
</script>

<template>
  <BModal
    :visible="visible"
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <div class="px-2 pb-2" data-testid="leaving-work-needed-modal-wrapper">
      <p>お仕事お疲れ様でした！</p>
      <p class="text-danger">
        未退勤のお仕事があります
      </p>
      <p class="text-danger">
        退勤予定日を過ぎているため、勤怠変更申請を行ってください
      </p>
      <div class="my-4">
        <WorkInfoTable
          :application="application"
          :isNotShowFinishWorkTime="true"
        />
      </div>
      <p>
        給与は勤怠変更申請が承認され次第、申請内容をもとにウォレットに反映されます
      </p>
      <AppButton block :to="attendanceCorrectionRoute" class="mt-3">
        勤怠変更申請する
      </AppButton>
    </div>
  </BModal>
</template>
